
import React, {useState} from "react";
import { StyleSheet, Text, View, Button, ImageBackground,Image,Dimensions,TouchableOpacity, Alert} from "react-native";
import imgSrc2 from './images/clemgram_black.jpg';
import clem from './images/clemazon.jpg';
import shop from './images/shopnow.png';
import editt from './images/edit.png';

const Info = (props) => {

	return( 
		           
		<View style={styles.container}>
			<View style={{flexDirection:"row",alignItems:'left',justifyContent:'left',textAlign:'left'}}>
			<Image         
					style={styles.ichart}
					resizeMode={'center'}
					source={imgSrc2}/>
			<Text style={styles.text2}>Clemgram</Text>
			</View>
			<View style={{flexDirection:"column",alignItems:'center',justifyContent:'center',textAlign:'center',marginTop:20,marginRight:40,marginLeft:40}}>
		
			
				<Image         
					style={styles.ipro}
					resizeMode={'center'}
					source={clem}/>
			<TouchableOpacity style={{flexDirection:"row",alignItems:'center',justifyContent:'center',marginTop:5}}
			 onPress={() => {

				props.navigation.navigate('Clemazon1',{email: props.navigation.state.params.email});
				}}>
				<Image         
					style={styles.iedit}
					resizeMode={'center'}
					source={shop}/>
			</TouchableOpacity>


				</View>
		</View>
	
	)


}
//	{false}<Text style={styles.text4}>Your Facebook profile is where other people can post their thoughts, opinions, views, or criticisms about you for everyone to see. </Text>
                               
const styles = StyleSheet.create({
	container: {
		padding: 5,
		flex: 1,
		display: "flex",
		marginTop: 5,
		textAlign: 'center',
		flexDirection: "column",
		justifyContent: "center",
		backgroundColor:"black",
	},
	button: {
		alignItems: "center",
		backgroundColor: "#DDDDDD",
		padding: 10
	  },
	imageContainer: {
		padding: 1,
		marginTop: 1,
		textAlign: 'center',
        flexDirection: "row",
        paddingLeft: Dimensions.get('window').width/11,
		paddingRight: Dimensions.get('window').width/11,
		justifyContent: "center",
	},
	textContainer: {
		textAlign: 'center',
        flexDirection: "column",
		justifyContent: "center",
	},
	ichart: {
		height: Dimensions.get('window').height/15,
		width: Dimensions.get('window').width/13,
	  }, 
	  iedit: {
		height: Dimensions.get('window').height/10,
		width: Dimensions.get('window').width/8,
	  }, 
	  ipro: {
		height: Dimensions.get('window').height/1.5,
		width: Dimensions.get('window').width/1.5,
	  }, 
	  ipost: {
		height: Dimensions.get('window').height/3.5,
		width: Dimensions.get('window').width/3.5,
	  },
	buttonContainer:{
		width: '15%',
		alignSelf: 'center',
		marginTop: 80,
	},
	iweb2: {
		height: Dimensions.get('window').height/2.7,
		width: Dimensions.get('window').width/4,
		marginLeft: 1
	  },
	text: {
		
		fontSize: Dimensions.get('window').width/50,
		color:'#3a9BDC',
		marginRight: 5,
		marginLeft: 5,
	},
    text2: {
		//fontWeight: "bold",
		fontSize: 40,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'#FFA500',
		fontFamily: "sans-serif-condensed",
	},
    
    text4: {
		fontSize: 30,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text5: {
		fontSize: 23,        
        marginBottom: 15,
		fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'center',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	text6: {
		fontSize: 22,        
        marginBottom: 15,
		//fontStyle: 'italic',
		//marginTop:20,        
        textAlign: 'left',
		color:'white',
		fontFamily: "sans-serif-condensed",
	},
	image: {
		flex: 1,
		justifyContent: "center"
	  },
	buttonStyle: {
	alignItems: 'center',
	justifyContent: 'center',
	paddingVertical: 52,
	paddingHorizontal: 32,
	paddingTop: 20,
	borderRadius: 1,
	borderWidth:10,
	elevation: 13,
	backgroundColor:"#341ada"
	},
	listContainer: {
		paddingTop: 20
	},
	listItem: {
		fontSize: 20
	},
	text3: {
		marginTop: 20,        
        marginBottom: 20,        
        textAlign: 'center',
		fontSize: Dimensions.get('window').width/70,
		color:'#03C04A',
		marginRight: Dimensions.get('window').width/5,
		marginLeft: Dimensions.get('window').width/5,
		
	},
	  textAreaContainer: {
		
		paddingTop: 30,
		paddingRight:Dimensions.get('window').width/2.5,
		paddingLeft: Dimensions.get('window').width/2.5,
		paddingBottom: 30,
		textAlign: 'center',

	  },
	  textArea: {
		height: 50,
		width:250,
		fontSize: 16,
		borderColor: 'white',
		backgroundColor:'white',
		color:'black',
		borderWidth: 1,
		marginBottom: 20,
		justifyContent: "center"
	  },
	  checkboxContainer: {
		flexDirection: "row",
		
	  },
	  checkbox: {
		alignSelf: "center",
	  },
})
export default Info